import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIsolationMode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 24,
	viewBox: "0 0 23 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "isolation_mode",
		clipPath: "url(#clip0_855_8757)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20.9592 10.988C20.5548 10.988 20.2238 11.3192 20.2238 11.724V20.924C20.2238 21.5312 19.7274 22.028 19.1207 22.028H2.57394C1.96723 22.028 1.47082 21.5312 1.47082 20.924V4.36396C1.47082 3.75676 1.96723 3.25996 2.57394 3.25996H11.7666C12.1711 3.25996 12.502 2.92876 12.502 2.52396C12.502 2.11916 12.1711 1.78796 11.7666 1.78796H2.57394C1.15827 1.78796 0 2.93796 0 4.36396V20.924C0 22.3408 1.15827 23.5 2.57394 23.5H19.1207C20.5364 23.5 21.6946 22.3408 21.6946 20.924V11.724C21.6946 11.3192 21.3637 10.988 20.9592 10.988Z",
			fill: "black"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M22.2463 2.53316L20.9501 1.23596C20.4537 0.766755 19.8102 0.509155 19.13 0.509155C18.4497 0.509155 17.797 0.766755 17.3098 1.23596L6.26026 12.2852C6.12237 12.4232 6.04883 12.6072 6.04883 12.8004V16.7012C6.04883 17.106 6.37976 17.4372 6.78424 17.4372H10.6819C10.875 17.4372 11.068 17.3636 11.2059 17.2256L22.2555 6.16715C22.7427 5.67955 23.0093 5.03555 23.0093 4.34556C23.0093 3.65556 22.7427 3.01156 22.2555 2.52396L22.2463 2.53316ZM10.3694 15.9836H7.51046V13.1224L15.8758 4.75036L18.7347 7.61156L10.3694 15.9836ZM21.2075 5.13675L19.7734 6.57196L18.3394 5.14596L16.9145 3.71076L18.3486 2.27556C18.56 2.07316 18.8358 1.96276 19.1208 1.96276C19.4057 1.96276 19.6907 2.07316 19.9021 2.27556L21.1983 3.57276C21.4097 3.78436 21.5201 4.06036 21.5201 4.35476C21.5201 4.64916 21.4097 4.92516 21.1983 5.13675H21.2075Z",
			fill: "black"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_855_8757",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 23,
			height: 23,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgIsolationMode;
